// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { SystemUser } from '@Constants/organisation';
import { findUser } from '@Helpers/';
import IconLabel from '@Atoms/Info/IconLabel/IconLabel';
import UserAvatar from '@Atoms/UserAvatar/UserAvatar';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { classList } from '@Helpers/className';
import useListQuery from '@Hooks/useListQuery';
import client from '@Client';

import './AssigneeInfo.scss';

interface AssigneeInfoProps {
    assignee?: string;
    avatarOnly?: boolean;
    placement?: TooltipPlacement;
    noAvatar?: boolean;
    onClick?: (assignee: string) => void;
}

const AssigneeInfo = ({
    assignee = '',
    avatarOnly = false,
    noAvatar = false,
    onClick,
}: AssigneeInfoProps): ReactElement => {
    const { data: userList = [] } = useListQuery({
        controller: client.OrganisationController,
        queryParams: {
            selector: { head: [{ name: 'listVisibleUsers' }], name: 'get-visible-users' },
        },
        manual: true,
        fetchOnStart: false,
    });

    const assigneeUser = assignee !== SystemUser.login ? findUser(assignee, userList) : SystemUser;

    const { name = '', organisation = '', avatar = '' } = assigneeUser || {};

    return (
        <div className={classList('assignee-info', { clickable: !!onClick })} onClick={() => onClick?.(assignee)}>
            {avatarOnly ? (
                <UserAvatar
                    name={!!assigneeUser ? name : assignee}
                    avatar={avatar}
                    tooltipCustom={!!assigneeUser ? `${organisation}/${name}` : assignee}
                    showTooltip
                />
            ) : (
                <IconLabel
                    icon={!noAvatar && <UserAvatar name={!!assigneeUser ? name : assignee} avatar={avatar} />}
                    label={!!assigneeUser ? name : assignee}
                />
            )}
        </div>
    );
};

export default AssigneeInfo;
